import { TFunction } from "i18next";

import { ETasyScheduleTypeCode } from "../model";

const TRASNLATION_PATH = "page.schedules.mySchedules.";

interface IScheduleDescriptionData {
  tasyScheduleTypeCode?: number;
  procedureName?: string | null;
  physicianNameExecute?: string | null;
  calendarName?: string | null;
  tasySchedulingType?: {
    code?: string | number | null;
  };
  descriptionSite?: string | null;
}

export const getScheduleDescriptionLines = (
  data: IScheduleDescriptionData,
  t: TFunction,
) => {
  const scheduleTypeCode = String(
    data.tasyScheduleTypeCode ?? data.tasySchedulingType?.code ?? "",
  );

  if (scheduleTypeCode === ETasyScheduleTypeCode.EXAM) {
    const type = t(TRASNLATION_PATH + `type.${ETasyScheduleTypeCode.EXAM}`);
    const procedure = data.procedureName || data.descriptionSite || "-";
    const scheduleRoom = data.calendarName || "-";

    return t(TRASNLATION_PATH + "examDescription", {
      type,
      procedure,
      scheduleRoom,
    }).split("\n");
  }

  if (scheduleTypeCode === ETasyScheduleTypeCode.CONSULTATION) {
    const type = t(
      TRASNLATION_PATH + `type.${ETasyScheduleTypeCode.CONSULTATION}`,
    );
    const physicianName =
      data.physicianNameExecute || data.descriptionSite || "-";

    return t(TRASNLATION_PATH + "consultationDescription", {
      type,
      physicianName,
    }).split("\n");
  }

  return [data.descriptionSite || "-"];
};
